import { createSelector } from '@ngrx/store';
import * as EntertainmentEventReducers from '../reducers';
import * as EntertainmentEventPerformancesReducers from '../reducers/entertainment-event-performances.reducers';

export const getEntertainmentEventPerformancesFeatureState = createSelector(
  EntertainmentEventReducers.getEntertainmentEventState,
  (state: EntertainmentEventReducers.EntertainmentEventState) => state.entertainmentEventPerformances
);

export const getPerformanceList = createSelector(
  getEntertainmentEventPerformancesFeatureState,
  EntertainmentEventPerformancesReducers.getPerformancesList
);
export const getSelectedPerformance = createSelector(
  getEntertainmentEventPerformancesFeatureState,
  EntertainmentEventPerformancesReducers.getSelectedPerformance
);
